import { render, staticRenderFns } from "./ProductQuickSearchModal.vue?vue&type=template&id=672de034&scoped=true&"
import script from "./ProductQuickSearchModal.vue?vue&type=script&lang=js&"
export * from "./ProductQuickSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductQuickSearchModal.vue?vue&type=style&index=0&id=672de034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672de034",
  null
  
)

export default component.exports